import script from "./AlbumImagesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumImagesGrid.vue?vue&type=script&setup=true&lang=js"

import "./AlbumImagesGrid.vue?vue&type=style&index=0&id=77995772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77995772"]])

export default __exports__